import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import ProfileScreen from '../components/ProfileScreen';
import DeleteAccountSection from '../components/DeleteAccountSection';
import PaymentService from '../services/payment';
import toast from 'react-hot-toast';

export default function ProfilePage() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try { await signOut(); } catch { /* already signed out */ }
    navigate('/login', { replace: true });
  };

  const handleManageSubscription = async () => {
    try { await PaymentService.manageSubscription(); }
    catch (err) { toast.error(err.message || 'Could not open subscription portal'); }
  };

  return (
    <div className="space-y-4">
      <ProfileScreen
        onBack={() => navigate('/')}
        onUpgrade={() => navigate('/subscribe')}
        onManageSubscription={handleManageSubscription}
      />

      <div className="card">
        <h3 className="section-title">Legal</h3>
        <div className="flex flex-col gap-2">
          <a
            href="/privacy.html"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary-600 dark:text-primary-400 underline"
          >
            Privacy Policy
          </a>
          <a
            href="/terms.html"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary-600 dark:text-primary-400 underline"
          >
            Terms of Use (EULA)
          </a>
        </div>
      </div>

      <DeleteAccountSection />

      <button type="button" onClick={handleSignOut} className="btn-danger w-full">
        Sign Out
      </button>
    </div>
  );
}
